window.addEventListener("DOMContentLoaded", () => {
    
    // Input text/email/password
    const inputFieldText = document.querySelectorAll('.formGroup__input.text')
    const inputFieldEmail = document.querySelectorAll('.formGroup__input.email')
    const inputFieldPassword = document.querySelectorAll('.formGroup__input.password')

    let clearField = (inputField) => {
        if(inputField){
            inputField.forEach((el) => {
                let thisInput = el.querySelector("input")
                let thisClear = el.querySelector(".clearField")

                if (thisInput.value){
                    thisClear.classList.add("active")
                }

                thisClear.addEventListener("click", (e) => {
                    thisInput.value=''
                    thisClear.classList.remove("active")
                })

                thisClear.addEventListener('keypress', function (e) {
                    if (e.key === 'Enter') {
                        thisInput.value=''
                        thisClear.classList.remove("active")
                    }
                });

                thisInput.addEventListener("keyup", (e) => {
                    if(thisInput.value.length !== 0){
                        thisClear.classList.add("active")
                    } else{
                        thisClear.classList.remove("active")
                    }
                }) 

            })
        }
    }
    clearField(inputFieldText)
    clearField(inputFieldEmail)
    clearField(inputFieldPassword)

    let showPassword = (inputField) => {
        if(inputField){
            inputField.forEach((el) => {
                let thisInput = el.querySelector("input")
                let thisShowPassword = el.querySelector(".showPassword")

                thisShowPassword.addEventListener("click", (e) => {
                    if(thisInput.type == "password"){
                        thisInput.type = "text"
                    } else{
                        thisInput.type = "password"
                    }
                })

                thisShowPassword.addEventListener('keypress', function (e) {
                    if (e.key === 'Enter') {
                        if(thisInput.type == "password"){
                            thisInput.type = "text"
                        } else{
                            thisInput.type = "password"
                        }
                    }
                });

            })
        }
    }
    showPassword(inputFieldPassword)

    // Toggle "checked" for checkbox, radio button and switch
    const taggleSwitch = document.querySelectorAll('.switch:not(.disabled)')
    const radioButton = document.querySelectorAll('.radioButton:not(.disabled)')
    const checkbox = document.querySelectorAll('.checkbox:not(.disabled)')

    let toggleInputsState = (inputField) => {
        if(inputField){
            inputField.forEach((el) => {
                let thisInput = el.querySelector("input")
                el.addEventListener('keypress', function (e) {
                    if (e.key === 'Enter') { 
                        thisInput.toggleAttribute("checked")
                    }
                })
            })
        }
    }
    
    toggleInputsState(taggleSwitch)
    toggleInputsState(radioButton)
    toggleInputsState(checkbox)

    // Helper
    const helpItem = document.querySelectorAll('.formGroup .help')

    let helpItemPreventDefault = (inputField) => {
        if(inputField){
            inputField.forEach((el) => {
                el.addEventListener('click', function (e) {
                    e.preventDefault() 
                })
                el.addEventListener('keypress', function (e) {
                    if (e.key === 'Enter') { 
                        e.preventDefault() 
                    }
                })
            })
        }
    }
    
    helpItemPreventDefault(helpItem)

})